// src/App.js
import './App.css';
import Navbar from './components/Navbar/Navbar';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "font-awesome/css/font-awesome.min.css";

import AppRoutes from './AppRoutes';
import { BrowserRouter, useLocation } from "react-router-dom";
import { CartProvider } from './contextPage/CartContext';
import { UserProvider } from './contextPage/UserContext';

function AppWrapper() {
  const location = useLocation();
  const hideNavbar = location.pathname === "/login"; // 👈 conditionally hide

  return (
    <>
      {!hideNavbar && <Navbar />}
      <AppRoutes />
      {!hideNavbar && (
        <a
          href="https://wa.me/917204429777"
          className="whatsapp-float"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://cdn-icons-png.flaticon.com/512/124/124034.png"
            alt="WhatsApp"
          />
        </a>
      )}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <UserProvider>
          <CartProvider>
            <AppWrapper /> {/* now handles conditional layouts */}
          </CartProvider>
        </UserProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
